import React from 'react';
import Background from '../components/Background';
import OngoingProjects from '../components/OngoingProjects';

const OngoingPage = () => {
  return (
    <>
      <Background />
      <div className="page">
        <OngoingProjects />
      </div>
    </>
  );
};

export default OngoingPage;
